<p>category-result-distribution-table works!</p>
